import {ComponentPropsWithoutRef} from 'react';
import {Controller, Control, FieldValues, Path} from 'react-hook-form';
import {Input} from "@/components/tailwind/input.tsx";

type NullableTextInputProps<T extends FieldValues> = {
    name: Path<T>;
    control: Control<T>;
} & Omit<ComponentPropsWithoutRef<typeof Input>, 'name' | 'value' | 'onChange' | 'type'>;

export function NullableTextInput<T extends FieldValues>({
    name,
    control,
    ...props
}: NullableTextInputProps<T>) {
    return (
        <Controller
            name={name}
            control={control}
            render={({field: {ref: _ref, onChange, value, ...fieldProps}}) => (
                <Input
                    type="text"
                    value={value ?? ''}
                    onChange={e => onChange(e.target.value.trim() || null)}
                    {...fieldProps}
                    {...props}
                />
            )}
        />
    );
}
